var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"timeout":_vm.timeout,"color":_vm.color,"top":"","right":""},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_vm._v(" "+_vm._s(_vm.message)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }